import React, { useEffect } from "react";
// import "../styles/Home.css";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <div className="homepage">
      {/* Hero Section */}
      <section className="hero" id="home">
        <div className="hero-content">
          <h1>Reddy Anna Official - Get Reddy Anna Online ID & Cricket ID</h1>
          <p>
            Welcome to Reddy Anna Book
          </p>
          <p>
            India’s most experienced and trusted fantasy sports platform—delivering reliable <a href="https://reddyannaofficial.social/cricket-betting">Reddy Anna Official Cricket IDs</a> and 24/7 support since 2010.
          </p>
          <p>
            Join the action and elevate your game with <a href="https://reddyannaofficial.social/reddy-anna-book">Reddy Anna Book!</a> Whether you're a seasoned fantasy cricket player or just starting out, we provide the tools and support to help you succeed. Analyze teams, predict performances, and bet smartly—all in one place.
         </p>
          <div className="home-btn">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="contactus-button"
            >
              Contact Us @ 7777077777
            </a>
            <br />
            <br />
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="contactus-button"
            >
              WhatsApp Us @ 7777077777
            </a>
          </div>
        </div>
        <div className="hero-image">
          <img
  src="/home.webp"   // ✅ FIXED
  alt="Fantasy Cricket Banner"
  loading="eager"
  fetchpriority="high"
  width="600"
  height="400"
/>
        </div>
      </section>

      {/* Support Section */}
      <section className="customer-support" id="support">
        <h2>
          Reddy Anna Official Customer Support – 24/7 WhatsApp Assistance for Reddy Anna ID
        </h2>
        <p>
         Need assistance with your <a href="https://reddyannaofficial.social/cricket-betting">Reddy Anna Official Cricket ID</a>, account, or platform queries? Our dedicated support team is available 24/7 via WhatsApp for immediate help with registration, deposits, withdrawals, or any general inquiries.
         </p>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Chat Now @ 7777077777
        </a>
      </section>
    </div>
  );
};

export default Home;
